iScreenWizard.controller('FaqController', function ($scope, $state, $mdDialog, Ajax, Dictionary, Faq, userService) {


    $scope.faqs = [];
    $scope.user = userService.model;

    $scope.searchTerm = "";

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        Faq.all().then(function (faqs) {
            $scope.faqs = faqs
        });
    });

});